import { useRef, useEffect } from 'react';

/**
 * @deprecated
 * use useInterval from 'usehooks-ts' instead
 */
export function useInterval(callback, delay) {
  const savedCallback = useRef();
  const clearCallback = useRef();

  useEffect(
    () => {
      savedCallback.current = callback;
    },
    [ callback ]
  );

  useEffect(
    // eslint-disable-next-line
    () => {
      if (delay !== null) {
        const id = setInterval(() => savedCallback.current(), delay);
        clearCallback.current = () => clearInterval(id);

        return clearCallback.current;
      }
    },
    [ delay ]
  );

  return {
    clear: clearCallback.current,
  };
}
